import { Close } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";

const ANALOG_COLOR = "#AD48C4";
const DIGITAL_COLOR = "#C46F48";

export interface SelectedTagDisplay {
	TagId: number;
	TagName: string;
	Alias: string | null;
	TagTypeCode: string;
}

interface SelectedTagsListV2Props {
	tags: SelectedTagDisplay[];
	onRemove: (tagId: number) => void;
	maxHeight?: number | string;
}

export const SelectedTagsListV2 = ({
	tags,
	onRemove,
	maxHeight = 140,
}: SelectedTagsListV2Props) => {
	return (
		<Box sx={{ mt: 1 }}>
			<Typography variant="caption" color="textSecondary" fontWeight={600}>
				{`Selected tags (${tags.length})`}
			</Typography>
			<Box
				sx={{
					mt: 0.5,
					maxHeight,
					minHeight: "28px",
					overflowY: "auto",
					border: "1px solid rgba(0, 0, 0, 0.12)",
					borderRadius: "4px",
					backgroundColor: "#fafafa",
				}}
			>
				{tags.map((tag) => (
						<Box
							key={tag.TagId}
							sx={{
								display: "flex",
								alignItems: "center",
								gap: "6px",
								padding: "2px 4px 2px 8px",
								borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
								"&:last-of-type": { borderBottom: "none" },
							}}
						>
							<Box
								component="span"
								sx={{
									flex: "0 0 auto",
									width: "20px",
									height: "20px",
									color: "white",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									fontSize: "10px",
									fontWeight: "bold",
									borderRadius: "3px",
									border: "1px solid rgba(0, 0, 0, 0.2)",
									backgroundColor:
										tag.TagTypeCode === "D" ? DIGITAL_COLOR : ANALOG_COLOR,
								}}
							>
								{tag.TagTypeCode === "D" ? "D" : "A"}
							</Box>
							<Typography
								variant="body2"
								sx={{
									fontSize: "0.8rem",
									overflow: "hidden",
									textOverflow: "ellipsis",
									whiteSpace: "nowrap",
								}}
							>
								{tag.Alias || tag.TagName}
							</Typography>
							{tag.Alias && tag.Alias !== tag.TagName && (
								<Typography
									variant="body2"
									sx={{
										fontSize: "0.8rem",
										color: "rgba(0, 0, 0, 0.6)",
										overflow: "hidden",
										textOverflow: "ellipsis",
										whiteSpace: "nowrap",
									}}
								>
									{`[${tag.TagName}]`}
								</Typography>
							)}
							<Box sx={{ flex: 1 }} />
							<Tooltip title="Remove tag" arrow>
								<IconButton
									size="small"
									onClick={() => onRemove(tag.TagId)}
									style={{ padding: "2px" }}
								>
									<Close style={{ height: "16px", width: "16px" }} />
								</IconButton>
							</Tooltip>
						</Box>
					))}
			</Box>
		</Box>
	);
};
